export const onChangeOnlyLetters = (value, onChange) => {
  if(/[a-zа-я ]/i.test(value.at(-1)))
    onChange(value)
}